module.exports = __webpack_public_path__ + "img/dropsBanner_600.9627f713.png";